/**
 * @module lib/toast
 * @summary Framework-agnostic toast bus.
 * @description The engine (and any module) calls `toast('message')`; the React
 *   <Toast> host subscribes via `onToast` and renders it. Replaces the original
 *   showToast() that poked a DOM element directly (line 4023).
 * @ported-from JCC PFD Engineering Tool v1.1.html lines 4022-4027.
 */
type ToastListener = (msg: string, ms: number) => void;

const listeners = new Set<ToastListener>();

/** Subscribe to toast messages. Returns an unsubscribe function. */
export function onToast(cb: ToastListener): () => void {
  listeners.add(cb);
  return () => listeners.delete(cb);
}

/** Show a transient toast message. */
export function toast(msg: string, ms = 2000): void {
  listeners.forEach((l) => l(msg, ms));
}
